export function svgUrl(name: string): string {
  return `https://images.clerk.dev/static/${name}.svg`;
}
